import styled from "@emotion/styled";
import { units } from "../../../../types/units";

export const StyledBorder = styled.div`
  position: relative;
  padding: 2rem;
  border: 1px solid;
  border-radius: 15px;
  margin: 0 0 2rem;
  ${units({
    borderColor: "lightGrey",
    backgroundColor: "white",
  })};

  h2,
  h3,
  h4 {
    margin-top: 0;
  }

  .hidden {
    display: none;
  }
`;
